<div class="card-list-wrapper ziti-page-container fullModal opened">
    <div class="card-list-content">
        <div class="card-list-title-container">
            <div (click)="back()" class="form-title-back-arrow-icon icon-back-arrow"></div>
            <div class="title" style="filter: brightness(50%)">Create a service</div>
        </div>
        <div class="subtitle">Choose a service type</div>
        <div class="card-list-container">
            <netfoundry-ui-service-card
                (cardClicked)="chooseSimple()"
                [buttonText]="'Create Simple Service'"
                [content]="'Simple services required fewer details, only asking for the most commonly used fields.'"
                [id]="'SimpleServiceCard'"
                [imageUrl]="'/assets/svgs/Simple.svg'"
                [title]="'Simple'"
            ></netfoundry-ui-service-card>
            <netfoundry-ui-service-card
                (cardClicked)="chooseAdvanced()"
                [buttonText]="'Create Advanced Service'"
                [content]="
                    'Advanced services allow you to configure any option supported by the controller but are subsequently a bit more complex.'
                "
                [id]="'AdvancedServiceCard'"
                [imageUrl]="'/assets/svgs/Advanced.svg'"
                [title]="'Advanced'"
            ></netfoundry-ui-service-card>
            <netfoundry-ui-template-service-card></netfoundry-ui-template-service-card>
        </div>
        <div (click)="back()" class="buttonBall close" id="EscZitiAWClose">
            <div class="buttonLabel">ESC</div>
        </div>
    </div>
</div>
